import { cn } from "@/domains/library"

export const ScaleCard300 = ({
  children,
  className,
  onClick,
  style,
}: {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void
}) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    if (onClick) {
      onClick(event)
    }
  }
  return (
    <div
      className={cn(
        "sc-card-300",
        "bg-p300",
        "border-p200-shade rounded-lg border",
        "transition-all duration-300 ease-in-out",
        className,
      )}
      onClick={handleClick}
      style={style}
    >
      {children}
    </div>
  )
}
